// extracted by mini-css-extract-plugin
export var statItem = "_kt-1";
export var statsRow = "_kt-0";